import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { LexiconModule } from '@galaxy/lexicon';
import baseTranslation from './assets/en_devel.json';

@NgModule({
  imports: [
    TranslateModule,
    LexiconModule.forChild({
      componentName: 'common/meeting-integrations',
      baseTranslation: baseTranslation,
    }),
  ],
})
export class MeetingIntegrationTranslationsModule {}
